// Self-contained data for the KVP Cabahug; Amigo-Escobar & Partners Law concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/07_KVP_Cabahug_Amigo_Escobar_Partners
// (research snapshot 2026-08-21), cross-checked against the firm's own official professional-card
// graphics (Atty. Analyn Basay, Atty. Rodmarc Sanchez) and business card (services/address). Reviews
// are placed contextually next to the relevant service rather than dumped in one list, per the brief.
export const SLUG = "kvp-cabahug-law-cebu-concept";

export const BIZ = {
  name: "KVP Cabahug; Amigo-Escobar & Partners Law",
  shortName: "KVP Law",
  address: "The Regency Crest, Maria Luisa Park Road, Banilad, Cebu City 6000",
  phone: "+639280624430",
  phoneDisplay: "+63 928 062 4430",
  phoneAlt: "(032) 413-5030",
  email: "ask@kvpcabahuglaw.com",
  emailAlt: "kvpcabahuglaw@gmail.com",
  website: "https://kvpcabahuglaw.com/",
  facebook: "https://www.facebook.com/108830735185408",
  hours: "Mon–Fri, 9:00 AM – 4:00 PM",
  slogan: "No case too big, no case too small. Any city. Any court. Any time.",
  mapEmbed: "https://www.google.com/maps?q=The+Regency+Crest+Maria+Luisa+Road+Banilad+Cebu+City&output=embed",
};

export const NAV_PAGES = [
  { key: "home", label: "Home", path: "" },
  { key: "practice-areas", label: "Practice Areas", path: "/practice-areas" },
  { key: "lawyers", label: "Our Lawyers", path: "/lawyers" },
  { key: "overseas", label: "Overseas Clients", path: "/overseas-clients" },
  { key: "contact", label: "Contact", path: "/contact" },
];

export const TEAM = [
  {
    name: "Atty. Karina Virginia Perpetua Cabahug, REB, REA, MMREM",
    role: "Founding & Managing Partner",
    photo: "/law/kvp-cabahug-law-cebu-concept/atty-cabahug.jpg",
    note: "Attorney, notary public, and a licensed real-estate broker and appraiser with a master's in real-estate management. Prior Senate legislative-team experience, law-school teaching and civic roles.",
  },
  {
    name: "Atty. Ma. Krishina Joy Amigo-Escobar",
    role: "Managing Partner",
    photo: "/law/kvp-cabahug-law-cebu-concept/atty-amigo-escobar.jpg",
    note: "JD valedictorian and licensed customs broker (reportedly ranked 4th in the customs-broker licensure exam), with OSG internship experience.",
  },
  {
    name: "Atty. Analyn Basay",
    role: "Attorney at Law, Notary Public",
    photo: "/law/kvp-cabahug-law-cebu-concept/atty-basay.jpg",
    note: "Key practice: civil, criminal and special proceedings; notarial services; administrative and regulatory compliance.",
  },
  {
    name: "Atty. Rodmarc Sanchez",
    role: "Attorney at Law",
    photo: "/law/kvp-cabahug-law-cebu-concept/atty-sanchez.jpg",
    note: "Key practice: criminal prosecution and defense, administrative case litigation, family cases, environmental protection and school law.",
  },
  {
    name: "Mark Jason Veloso, CPA, REB",
    role: "CPA & Licensed Real Estate Broker",
    photo: "/law/kvp-cabahug-law-cebu-concept/veloso.jpg",
    note: "Brings accounting and real-estate brokerage expertise to our property and business work.",
  },
];

export const OTHER_ASSOCIATED = "The firm's current social presence also lists Atty. Stephanie Sitoy, M.D. as part of the active legal team.";

export const PRACTICE_GROUPS = [
  {
    key: "property",
    title: "Property & Estate",
    areas: ["Land Titling & Title Transfer", "Subdivision & Consolidation of Title", "Property Due Diligence, Acquisition & Disposition", "Title Cancellation & Reconstitution", "Real Estate Law"],
    review: {
      quote: "Used the team for property due diligence for a buyer. Praises fast verification of property legitimacy and documents, professionalism, transparency and efficiency — giving the buyer confidence and peace of mind.",
      author: "Belinda",
      date: "May 2025",
    },
  },
  {
    key: "business",
    title: "Business & Corporate",
    areas: ["Business Registration & Corporate Housekeeping", "Business & Real-Estate Consultancy", "Sales & Contracts Law", "Construction Law"],
  },
  {
    key: "customs",
    title: "Customs & Tariff",
    areas: ["Customs & Tariff Law", "Permits, Licenses & Tax Compliance"],
  },
  {
    key: "disputes",
    title: "Disputes & Litigation",
    areas: ["Civil, Criminal & Corporate Litigation", "Immigration & Visa Concerns"],
    review: {
      quote: "Used Atty. Karina for a contractor dispute. Her expertise and support created confidence and ease — praised for how much she appeared to care about the client's concerns.",
      author: "Claude",
      date: "September 2025",
    },
  },
];

// The strongest recoverable review set in the legal batch (9 reviews, Lawzana). Two are used
// contextually above (property due diligence, contractor dispute) and two on the Overseas
// Clients page; the remainder appear on Contact as general feedback.
export const OVERSEAS_REVIEWS = [
  {
    quote: "Found Atty. KVP online — she was highly informative and made the process manageable while the client was abroad. Also praises Marven for responsiveness.",
    author: "Joyce",
    date: "August 2025",
  },
  {
    quote: "All transactions were handled online without meeting in person. Atty. Karina explained everything clearly, answered questions, remained available and provided very satisfactory service.",
    author: "Michelle",
    date: "July 2025",
  },
];

export const GENERAL_REVIEWS = [
  { quote: "Thanks the entire KVP team — completely satisfied with the service and highly recommends the firm.", author: "Name not shown", date: "July 2026" },
  { quote: "Atty. KVP was very hands-on from the beginning, clearly explained the case flow and pros/cons, and responded quickly despite a busy schedule.", author: "Name not shown", date: "June 2026" },
  { quote: "Describes the attorney as friendly, knowledgeable, direct, professional, genuine and committed.", author: "Nelson", date: "June 2026" },
  { quote: "Highly recommends Atty. Karina Cabahug for professionalism, strong legal knowledge and genuine commitment from the first consultation.", author: "Sean", date: "June 2026" },
];

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "9 reviews on Lawzana",
};
